// @flow
import useIntegration from 'hooks/useIntegration'
import usePermissions from 'hooks/usePermissions'
import { FormBuilderContext } from 'pages/Contexts/FormBuilderContext'
import * as React from 'react'
import Button from 'ui/atoms/Button'
import Heading from 'ui/atoms/Heading'
import Space from 'ui/atoms/Space'
import TextField from 'ui/molecules/TextField'
import ToggleField from 'ui/molecules/ToggleField'
import Select from 'ui/Select'
import { ZentakeContext } from 'utils/ZentakeContext'

import cn from '@/utils/tailwind/cn'

function BuilderSideMenuEditForm(): React.Node {
  const {
    autoSignOffEnabled,
    elationPdfNonFax,
    formReportType,
    setAutoSignOffEnabled,
    setElationPdfNonFax,
    setFormReportType,
    measuresEnabledForm,
    formName,
    setFormName,
    serverFormId,
    getOnDeleteForm,
  } = React.useContext(FormBuilderContext)

  const { teamDetails } = React.useContext(ZentakeContext)

  const measuresEnabled = teamDetails.measures

  const { integration, integrationReports, integrationTitledName } =
    useIntegration()

  const [integrationReportsSearch, setIntegrationReportsSearch] =
    React.useState('')

  const integrationReportsOptions = React.useMemo(() => {
    return integrationReports
      .filter(
        (report) =>
          integrationReportsSearch === '' ||
          report.label
            .toLowerCase()
            .includes(integrationReportsSearch.toLowerCase())
      )
      .sort((a, b) => a.label.localeCompare(b.label))
      .map((report) => ({
        value: report.label,
        label: report.label,
      }))
  }, [integrationReports, integrationReportsSearch])

  const auto_sign_off_enabled =
    !!teamDetails?.integration?.auto_sign_off_enabled

  const { canDeletePacketForm, canEditPacketForm } = usePermissions()

  const removeIntegration = () => {
    setFormReportType('')
  }

  const resourceType = 'form'

  return (
    <Space size="xlarge">
      <Space
        className={cn({
          'pointer-events-none cursor-not-allowed select-none opacity-60':
            measuresEnabledForm && measuresEnabled,
        })}
        size="large"
      >
        <Heading>Form</Heading>
        <Space>
          <TextField
            block
            label="Form name"
            name="form-name"
            onChange={(value) => {
              setFormName(value)
            }}
            placeholder="Form name"
            value={formName}
          />
        </Space>
        {!!integration && integrationReports.length > 0 && (
          <>
            <div className="mb-3 mt-6 border-b pb-1">
              <button
                className={`relative top-1 float-right text-sm ${
                  !formReportType ? 'text-red-200' : 'text-red-500'
                }`}
                disabled={!formReportType}
                onClick={removeIntegration}
              >
                Clear
              </button>
              <p className="font-medium text-txt-emphasis">
                Integration - {integrationTitledName}
              </p>
            </div>
            <div>
              <Select
                grayOutWhenDisabled
                showOptions
                disabled={!canEditPacketForm || elationPdfNonFax}
                label="PDF Integration"
                onChange={(option) => {
                  setFormReportType(option?.value || null)
                }}
                onType={setIntegrationReportsSearch}
                options={integrationReportsOptions}
                placeholder="Select a report type"
                value={integrationReportsOptions.find(
                  (option) => option.value === formReportType
                )}
                valueProp="value"
                willShowNotAllowedCursor={
                  !canEditPacketForm || elationPdfNonFax
                }
              />
            </div>
            {resourceType === 'form' && (
              <>
                <ToggleField
                  compact
                  grayOutWhenDisabled
                  horizontal
                  lightLabel
                  primary
                  disabled={!auto_sign_off_enabled}
                  label="Auto Sign Off"
                  onChange={() => {
                    setAutoSignOffEnabled(!autoSignOffEnabled)
                  }}
                  value={autoSignOffEnabled}
                />
                <ToggleField
                  compact
                  grayOutWhenDisabled
                  horizontal
                  lightLabel
                  primary
                  label="Send to Unfiled (non-fax)"
                  onChange={() => {
                    setElationPdfNonFax(!elationPdfNonFax)
                    removeIntegration()
                  }}
                  value={elationPdfNonFax}
                  // disabled={!auto_sign_off_enabled}
                />
              </>
            )}
          </>
        )}
      </Space>
      {canDeletePacketForm && (
        <Button
          $block
          $danger
          disabled={!serverFormId}
          onClick={getOnDeleteForm(serverFormId)}
        >
          Delete Form
        </Button>
      )}
    </Space>
  )
}

export default BuilderSideMenuEditForm
